<template>
  <div>
    <el-col :span="24"
            class="main">
      <!--左侧导航-->
      <aside :class="{showSidebar:!collapsed}">
        <!--展开折叠开关-->
        <div class="menu-toggle"
             @click.prevent="collapse">
          <i class="iconfont icon-outdent"
             v-show="!collapsed"
             title="收起"></i>
          <i class="iconfont icon-indent"
             v-show="collapsed"
             title="展开"></i>
        </div>
        <el-col :span="4">
          <el-radio-group v-model="isCollapse"
                          style="margin-bottom: 20px;">
            <el-radio-button :label="false">展开</el-radio-button>
            <el-radio-button :label="true">收起</el-radio-button>
          </el-radio-group>
          <el-menu :default-active="defaultActive"
                   class="el-menu-vertical-demo"
                   :collapse="isCollapse"
                   @open="handleOpen"
                   @close="handleClose"
                   @select="selectM">
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>进度管理</span>
              </template>
              <el-menu-item-group>
                <!-- <template slot="title">分组一</template> -->
                <el-menu-item index="map">安装计划可视化</el-menu-item>
                <el-menu-item index="gantt">采购计划可视化</el-menu-item>
                <el-menu-item index="edit">安装状态可视化</el-menu-item>
                <el-menu-item index="tree">采购状态可视化</el-menu-item>
                <el-menu-item index="video">查看生产计划</el-menu-item>
              </el-menu-item-group>

            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">文档管理</span></template>
              <el-menu-item-group>
                <!-- <template slot="title">分组一</template> -->
                <el-menu-item index="2-1">安装计划可视化</el-menu-item>
                <el-menu-item index="2-2">采购计划可视化</el-menu-item>
                <el-menu-item index="2-3">安装状态可视化</el-menu-item>
                <el-menu-item index="2-4">采购状态可视化</el-menu-item>
                <el-menu-item index="2-5">查看生产计划</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="3"
                        disabled>
              <template slot="title"><i class="el-icon-document"></i>
                <span slot="title">三维沙盘</span></template>
              <el-menu-item-group>
                <!-- <template slot="title">分组一</template> -->
                <el-menu-item index="1-1">安装计划可视化</el-menu-item>
                <el-menu-item index="1-2">采购计划可视化</el-menu-item>
                <el-menu-item index="1-1">安装状态可视化</el-menu-item>
                <el-menu-item index="1-2">采购状态可视化</el-menu-item>
                <el-menu-item index="1-1">查看生产计划</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title"><i class="el-icon-setting"></i>
                <span slot="title">个人中心</span></template>
              <el-menu-item-group>
                <!-- <template slot="title">分组一</template> -->
                <el-menu-item index="1-1">安装计划可视化</el-menu-item>
                <el-menu-item index="1-2">采购计划可视化</el-menu-item>
                <el-menu-item index="1-1">安装状态可视化</el-menu-item>
                <el-menu-item index="1-2">采购状态可视化</el-menu-item>
                <el-menu-item index="1-1">查看生产计划</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-col>
        <!--导航菜单-->
        <!-- <el-menu router :collapse="collapsed" ref="leftNavigation">
        <template v-for="(issue,index) in $router.options.routes">
          <template v-if="issue.name === $store.state.leftNavState"> -->
        <!-- 注意：这里就是leftNavState状态作用之处，当该值与router的根路由的name相等时加载相应菜单组 -->
        <!-- <template v-for="(item,index) in issue.children">
              <el-submenu v-if="!item.leaf"  :index="index+''" v-show="item.menuShow">
                <template slot="title"><i :class="item.iconCls"></i><span slot="title">{{item.name}}</span></template>
                <el-menu-item v-for="term in item.children" :key="term.path" :index="term.path" v-if="term.menuShow"
                              :class="$route.path==term.path?'is-active':''">
                  <i :class="term.iconCls"></i><span slot="title">{{term.name}}</span>
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-else-if="item.leaf&&item.children&&item.children.length" :index="item.children[0].path"
                            :class="$route.path==item.children[0].path?'is-active':''" v-show="item.menuShow">
                <i :class="item.iconCls"></i><span slot="title">{{item.children[0].name}}</span>
              </el-menu-item>
            </template>
          </template>
        </template>
      </el-menu> -->
      </aside>
      <!--右侧内容区-->
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col :span="24"
                  class="content-wrapper">
            <transition name="fade"
                        mode="out-in">
              <!-- <router-view></router-view> -->
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>
  </div>
</template>
<script>
export default {
  name: 'leftMenu',
  data() {
    return {
      collapsed: false,
      isCollapse: false,
      defaultActive: 'map'
    }
  },
  mounted() {
    this.defaultLeftNavOpened()
    this.initDefaultActive()
  },
  methods: {
    selectM(index, indexpath) {
      console.log(indexpath)
      this.$router.push({ path: index })// 详情
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    // 折叠导航栏
    collapse: function() {
      this.collapsed = !this.collapsed
    },
    initDefaultActive(val) {
      console.log(this.$route.path)
      this.$route.path.length <= 1 && this.$router.push({ path: 'map' })
      this.defaultActive = this.$route.path.substr(1)
      // Vue.prototype.$this.defaultActive = '/entrustOrderList'

      // 刷新左边菜单栏选中
      // var _str = this.$route.path.split('/');
      // this.defaultActive = "/"+_str[1];
    },
    // 左侧导航栏根据当前路径默认打开子菜单（如果当前路由是三级，则父级子菜单默认打开）
    defaultLeftNavOpened() {
      // let cur_path = this.$route.path; //获取当前路由
      // let routers = this.$router.options.routes; // 获取路由对象
      // let subMenuIndex = 0, needOpenSubmenu = false;
      // for (let i = 0; i < routers.length; i++) {
      //   let children = routers[i].children;
      //   if(children){
      //     for (let j = 0; j < children.length; j++) {
      //       if (children[j].path === cur_path) {
      //         break;
      //       }
      //       // 如果该菜单下有子菜单(个数>1且设置的leaf为false才有下拉子菜单)
      //       if(children[j].children && !children[j].leaf) {
      //         let grandChildren = children[j].children;
      //         for(let z=0; z<grandChildren.length; z++) {
      //           if(grandChildren[z].path === cur_path) {
      //             subMenuIndex = j;
      //             needOpenSubmenu = true;
      //             break;
      //           }
      //         }
      //       }
      //     }
      //   }
      // }
      // if(this.$refs['leftNavigation'] && needOpenSubmenu) {
      //   this.$refs['leftNavigation'].open(subMenuIndex); // 打开子菜单
      // }
      // this.$router.push({path: 'activityDetail/'+guid});//详情
    }
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/components/mind/leftmenu.vue